import { SAMPLE_UNITS } from '~/widgets/CostBomDemo/strings'

/**
 * Formatting shared by the BoM table and the summary band above it.
 *
 * Both render the same figures, so they have to round the same way; keeping one
 * implementation here is what stops `$32.9` in a row from reading as `$32.94`
 * in the band. Mirrors the platform's own `formatQuantity`: 3 significant
 * figures.
 */
export function formatQuantity(value: number, sigFigs = 3) {
  if (value == null || Number.isNaN(value)) return '--'
  if (value === 0) return '0'
  return value.toLocaleString('en-US', { maximumSignificantDigits: sigFigs })
}

export function formatMoney(value: number) {
  return `$${formatQuantity(value)}`
}

/** A sample's mass in the unit its table column uses. */
export function formatMass(value: number, sampleKey: string) {
  const unit = SAMPLE_UNITS[sampleKey] || SAMPLE_UNITS.default
  return `${formatQuantity(value * unit.massFactor)} ${unit.mass}`
}
